import $ from 'jquery';
import './bootstrap';
import 'jquery-match-height';
import './components/select2';
import './components/anchor-link.js';
import { initCandidateButtons } from './candidate_button';
window.$ = $;
window.jQuery = $;
window.createTag = function (tag, attributes) {
  const el = document.createElement(tag);
  Object.entries(attributes).forEach(([key, value]) => {
    el[key] = value;
  });
  return el;
}

if ('onbeforeprint' in window) {
  window.addEventListener('beforeprint', () => {
    document.querySelectorAll('img[loading="lazy"]').forEach(img => {
      img.loading = 'eager'
    });
  });
}

function tableWrap(el) {
  let tableEls = el.querySelectorAll('table');
  if (tableEls.length > 0) {
    tableEls.forEach(table => {
      let parent = table.parentElement;
      if (parent && parent.classList.contains('c-wysiwyg__wrap')) {
        return;
      }
      let wrapper = document.createElement('div');
      wrapper.classList.add('c-wysiwyg__wrap');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  let naviCandidateEl = document.getElementById('naviCandidate');
  if (naviCandidateEl && window.innerWidth <= 768) {
    naviCandidateEl.dataset.lightbox = 'lightboxCandidate';
  }

  let wysiwygEls = document.querySelectorAll('.c-wysiwyg');
  if (wysiwygEls.length > 0) {
    wysiwygEls.forEach(el => {
      tableWrap(el);
    });
  }

  initCandidateButtons();
  const carouselEls = document.querySelectorAll('.splide');
  if (carouselEls.length > 0) {
    const { renderCarousel } = await import('./components/carousel.js');
    renderCarousel();
  }

  const lightboxEls = document.querySelectorAll('.jsLightbox');
  if (lightboxEls.length > 0) {
    const { renderLightbox } = await import('./components/lightbox.js');
    renderLightbox();
  }

  const tabEls = document.querySelectorAll('.jsTabUser, .jsTabTtl');
  if (tabEls.length > 0) {
    const { renderTabUser, renderTab } = await import('./components/tab.js');
    renderTabUser(tabEls);
    renderTab();
  }

  const tooltipEls = document.querySelectorAll('.jsTooltip');
  if (tooltipEls.length > 0) {
    const { renderTooltip } = await import('./components/tooltip.js');
    renderTooltip(tooltipEls);
  }

  const select2Els = document.querySelectorAll('.jsSelect2, .jsSelectSingle');
  if (select2Els.length > 0) {
    const { renderselect2 } = await import('./components/select2.js');
    renderselect2();
  }

  const fixHeightEls = document.querySelectorAll('.jsFixHeightTitle, .jsFixHeightDetail');
  if (fixHeightEls .length > 0) {
    const { renderEqualHeight } = await import('./components/fixHeight.js');
    renderEqualHeight();
  }

  const stickyEl = document.getElementById('jsSticky');
  if (stickyEl) {
    const { renderSticky } = await import('./components/sticky.js');
    renderSticky(stickyEl);
  }

  const sideStickyEl = document.getElementById('jsSideSticky');
  if (sideStickyEl) {
    const { renderStickySide } = await import('./components/sticky-sidebar.js');
    renderStickySide();
  }

  const searchBoxEl = document.getElementById('jsSearchBox');
  if (searchBoxEl) {
    const { renderSearch } = await import('./components/search.js');
    renderSearch(searchBoxEl);
  }

  const historyNavSearchEl = document.getElementsByClassName('c-breadcrumb__history');
  if (historyNavSearchEl.length > 0) {
    $('nav.c-breadcrumb').addClass('c-breadcrumb--width');
    document.getElementsByClassName('c-breadcrumb')[0].classList.add('c-breadcrumb--width')
  }

  const tabs = document.querySelectorAll('[data-tabs]');
    if (tabs.length) {
    const { renderTabs } = await import('./components/tab.js');

    tabs.forEach(tab => {
        renderTabs(tab);
    });
    }
});

$(function() {
	$('.jsMatchHeight').matchHeight({ byRow: true });
  document.querySelectorAll('.jsReadmore').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const testimonials = this.closest('.c-testimonials-wrap');
      if (!testimonials) return;
      testimonials.classList.toggle('is-open');
    });
  });
});
